<div class="donut-card">
    <div class="donut-card-header">
        <div>
            <div class="donut-title">{{ title }}</div>
            <div class="donut-subtitle">
                <span *ngIf="title.toLowerCase().includes('original')">
                    {{ 'new_entries.distribution_by_submission_language' | translate }}
                </span>
                <span *ngIf="!title.toLowerCase().includes('original')">
                    {{ 'new_entries.relative_distribution_of_translated_languages' | translate }}
                </span>
            </div>
        </div>
        <div class="donut-filters">
            <label>{{ 'new_entries.year' | translate }}</label>
            <select [(ngModel)]="selectedYear" (change)="onYearChange()">
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
        </div>
    </div>
    <div class="donut-chart-container">
        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
            [colors]="chartOptions.colors" [legend]="chartOptions.legend" [dataLabels]="chartOptions.dataLabels"
            [fill]="chartOptions.fill" [plotOptions]="chartOptions.plotOptions"
            [responsive]="chartOptions.responsive"></apx-chart>
        <div class="donut-center">
            <div class="donut-total">{{ apiTotalSubmissions }}</div>
            <div class="donut-center-label">{{ 'new_entries.total_documents' | translate }}</div>
        </div>
    </div>
</div>